query ApprovalTestGroups {
  approvalTestGroups(orderBy: NAME_ASC) {
    nodes {
      id
      _rowTimestamp
      name
      description
      approvalTestItems {
        nodes {
          id
          _rowTimestamp
          comment
          businessUnitId
          businessUnit {
            name
          }
          departmentId
          department {
            name
          }
          totalAmount
          currencyId
          currency {
            isoCode
          }
          companyPhaseTypeId
          approvalPhase {
            phaseName
          }
          requesterUserProfileId
          activeProfile {
            name
          }
          userGroupId
          userGroup {
            name
          }
          workgroupId
          workgroup {
            name
          }
          transactionHintId
          approverTransactionType {
            approvalTransactionType
          }
          purchaseOrderTypeId
          purchaseOrderType {
            purchaseOrderType
          }
          tagId
          tag {
            name
          }
          elapsedDays
          approvalLevelValueId
          approvalLevelValue {
            name
          }
          userRankId
          userRankType {
            userRank
          }
          rowSecurityId
          secureRowLevel {
            name
          }
          additionalBusinessUnitId
          additionalBusinessUnit {
            name
          }
          additionalDepartmentId
          additionalDepartment {
            name
          }
          additionalAmount
        }
      }
    }
    totalCount
  }
}

